import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {RootState} from "../../app/store"
interface LightModeInterface {
isLight : string | null
}

const initialState:LightModeInterface = {
  isLight:
    localStorage.getItem("theme") !== null
      ? localStorage.getItem("theme")
      : "light",
};

export const darkModeSlice = createSlice({
  name: "darkmode",
  initialState,
  reducers: {
    toggleDark: (state):void => {
      state.isLight = "dark";
      localStorage.setItem("theme", "dark");
    },
    toggleLight: (state):void => {
      state.isLight = "light";
      localStorage.setItem("theme", "light");
    },
  },
});

export const { toggleLight, toggleDark } = darkModeSlice.actions;
export const mode =(state:RootState)=>state.darkModeReducer.isLight
export default darkModeSlice.reducer;
